__turbopack_context__.v({
  "author-link": "PrsQuW_author-link",
  "blog-card": "PrsQuW_blog-card",
  "category-link": "PrsQuW_category-link",
  "title": "PrsQuW_title",
});
